import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
declare var require: any;
import {
  ChronoField, DateTimeFormatter, LocalDate, LocalTime, nativeJs, TemporalField, use, ZonedDateTime, ZoneId, ZoneOffset,
  ZoneRegion, DateTimeFormatterBuilder, IsoFields, LocalDateTime,
} from 'js-joda'
import TIMEZONES from "./timezones";
import {TimezoneService} from "app/Services/timezone/timezone.service";
import {AppointmentsService} from "../../Services/appointments/appointments.service";
import {Timezone} from "../../Models/Timezone";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {CookieService} from 'angular2-cookie/services/cookies.service';
import {Observable} from "rxjs/Observable";
import {scrollToElement} from '../../helpers';

use(require('js-joda-timezone'));

@Component({
  selector: 'app-time-selector',
  templateUrl: './time-selector.component.html',
  styleUrls: ['./time-selector.component.scss']
})
export class TimeSelectorComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() openTimeZoneSelector = new EventEmitter();

  DAY_OF_MONTH = ChronoField.DAY_OF_MONTH;
  DAY_OF_WEEK = ChronoField.DAY_OF_WEEK;
  MONTH_OF_YEAR = ChronoField.MONTH_OF_YEAR;
  HOUR_OF_DAY = ChronoField.HOUR_OF_DAY;
  ofPattern = DateTimeFormatter.ofPattern;

  weekConvert = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
  };

  monthConvert = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  };

  timezones = TIMEZONES;
  headerTitle = "Pick a Time";
  headerComponent = TimeSelectorHeaderComponent;
  selectedJoda: LocalDate;
  aptMinutes = '60';

  selectDateTime(date: LocalDate, zonedTime: ZonedDateTime, timezoneDate: any) {
    let finalDate: ZonedDateTime = date.atTime(zonedTime.toLocalTime()).atZone(zonedTime.zone());
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);
    this.selectedDateTime.emit({finalDate: finalDate, timezone: timezoneDate});
  }

  @Output() selectedDateTime = new EventEmitter();

  convertTime(time: ZonedDateTime): ZonedDateTime {
    return time.withZoneSameInstant(this.timezoneService.timezone.zoneId);
  }

  timezoneService: TimezoneService;
  appointmentTimeService: AppointmentsService;

  constructor(timezoneService: TimezoneService, appointmentTimeService: AppointmentsService) {
    this.timezoneService = timezoneService;
    this.timezoneService.openTimeZone.subscribe(timezone => {
      this.openTimeZoneSelector.emit(timezone);
    });
    this.appointmentTimeService = appointmentTimeService;
    if ( window['ngRoot'] !== null ) {
      this.aptMinutes = window['ngRoot'].getAttribute('data-minutes') || '60';
    }
  }

  @Input()
  set selectedDate(date: Date) {
    this.selectedJoda = LocalDate.from(nativeJs(date));
  }

  times = {};

  safeGetTimes(date: LocalDate) {
    if (this.times.hasOwnProperty(date.toString())) {
      return this.times[date.toString()];
    } else {
      return [];
    }
  }

  loadTimes(current: LocalDate) {
    let obs: Observable<{ date: LocalDate, times: ZonedDateTime[] }>[] = [];
    for (let i of [-2, -1, 0, 1, 2]) {
      let date = current.plusDays(i);
      // if (!this.times.hasOwnProperty(date.toString())) {
        obs.push(
          this.appointmentTimeService.getTimes(date)
            .map((timesArr) =>
              timesArr.map((localTime) => ZonedDateTime.parse(date + "T" + localTime + window["appointmentTimezone"].substr(0, 3) + ":00" ))
            )
            .map((zonedDateTimes) => {
              return {date: date, times: zonedDateTimes}
            })
        )
      // }
    }
    Observable.merge(...obs)
      .subscribe((obj) => {
        this.times[obj.date.toString()] = obj.times;
      })
  }

  ngOnInit() {
    this.loadTimes(this.selectedJoda);
  }

  prevDate() {
    this.selectedJoda = this.selectedJoda.minusDays(1);
    this.loadTimes(this.selectedJoda);
  }

  nextDate() {
    this.selectedJoda = this.selectedJoda.plusDays(1);
    this.loadTimes(this.selectedJoda);
  }
}

@Component({
  selector: 'app-time-selector-header',
  /*template: `
    <div class="appbutton" (click)="this.timeZoneService.openTimeZone.next($event)">
      <i class="fa fa-globe" aria-hidden="true"> </i>
      ({{this.timeZoneService.timezone.abbreviation}})
    </div>
  `,*/
  template: `
    <div class="appbutton" (click)="this.timeZoneService.openTimeZone.next($event)" *ngIf="this.isReschedule === '' || this.isReschedule === undefined">
      {{this.timeZoneService.timezone.gmt}}
    </div>
  `,
  styles: [`.appbutton {
    font-size: 0.7em;
    user-select: none;
    cursor: default;
  }`]
})
export class TimeSelectorHeaderComponent {
  timeZoneService: TimezoneService;
  isReschedule = '';
  constructor(service: TimezoneService) {
    this.timeZoneService = service;
    this.isReschedule = CookieService.prototype.get('appointmentID');
  }
}



// WEBPACK FOOTER //
// /app/src/app/Components/time-selector/time-selector.component.ts